import { Injectable } from '@angular/core';
import { AccessLevels } from 'src/app/models/access_levels';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { AppAttributesService } from 'src/app/services/app-attributes.service';
import { WarningConfirmModalComponent } from 'src/app/pages/modal-pop-ups/warning-confirm-modal/warning-confirm-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService } from 'ngx-bootstrap';

interface MenuItem {
  title: string;
  type: string;
  badge?: {
    class: string;
    text: string;
  };
  link?: string;
  active?: boolean;
  icon?: string;
  image?: string;
  submenus?: MenuItem[];
}

@Injectable({
  providedIn: 'root'
})
export class SidebarMenuService {
  menus: MenuItem[] = [
    {
      "title": "Dashboard",
      "type": "simple",
      "icon": "assets/img/dashboard.svg",
      "image": "assets/img/dashboard-active.svg",
      "link": "/home/dashboard"
    },
    {
      "title": "Reservations",
      "type": "simple",
      "icon": "assets/img/my-bookings-icon.svg",
      "image": "assets/img/my-bookings-icon-active.svg",
      "link": "/home/bookings"
    },
    {
      "title": "Greets",
      "type": "simple",
      "icon": "assets/img/requests-new.svg",
      "image": "assets/img/requests-new-active.svg",
      "link": "/home/greets"
    },
    {
      "title": "Greet Requests",
      "type": "simple",
      "icon": "assets/img/bell-regular.svg",
      "image": "assets/img/bell-active.svg",
      "link": "/home/greet-request"
    },
    {
      "title": "Reports",
      "type": "dropdown",
      "icon": "assets/img/calandar-icon.svg",
      "image": "assets/img/calandar-icon-active.svg",
      "submenus": [
        {
          "title": "Concierge Payroll Report",
          "type": "simple",
          "icon": "<i class=\"ion-md-sync\"></i>",
          "link": "/home/reports",
        },
        {
          "title": "Canceled Reservations Report",
          "type": "simple",
          "icon": "<i class=\"ion-md-sync\"></i>",
          "link": "/home/reports/canceled-reservations",
        },
        {
          "title": "Monthly Invoice Reports",
          "type": "simple",
          "icon": "<i class=\"ion-md-sync\"></i>",
          "link": "/home/reports/monthly-invoice-reports",
        }
      ]
    },
    {
      "title": "Account Receivables",
      "type": "dropdown",
      "icon": "assets/img/my-account-icon.svg",
      "image": "assets/img/my-account-icon-active.svg",
      "submenus": [
        {
          "title": "AR Dashboard",
          "type": "simple",
          "link": "/home/ar-dashboard-charts"
        },
        {
          "title": "AR Transactions",
          "type": "simple",
          "link": "/home/ar-dashboard"
        },
        {
          "title": "AR Reports",
          "type": "simple",
          "link": "/home/ar-reports"
        }
      ]
    },
    {
      "title": "Customer Transactions",
      "type": "dropdown",
      "icon": "assets/img/my-account-icon.svg",
      "image": "assets/img/my-account-icon-active.svg",
      "submenus": [
        {
          "title": "Dashboard",
          "type": "simple",
          "link": "/home/customer-charts-dashboard"
        },
        {
          "title": "Transactions",
          "type": "simple",
          "link": "/home/customer-dashboard"
        }
      ]
    },
    {
      "title": "Administration",
      "type": "dropdown",
      "icon": "assets/img/settings.svg",
      "image": "assets/img/settings-active.svg",
      "submenus": [
        {
          "title": "Airlines",
          "type": "simple",
          "link": "/home/airlines"
        },
        {
          "title": "Stations",
          "type": "simple",
          "link": "/home/stations"
        },
        {
          "title": "Tax Slabs",
          "type": "simple",
          "link": "/home/tax"
        },
        {
          "title": "Concierge Members",
          "type": "simple",
          "link": "/home/employees"
        },
        {
          "title": "Outsourced Concierge Agencies",
          "type": "simple",
          "link": "/home/outsourceAgency"
        },
        {
          "title": "Contract Services",
          "type": "simple",
          "link": "/home/contracts"
        },
        {
          "title": "Promotional Services",
          "type": "simple",
          "link": "/home/promo-services"
        },
        {
          "title": "Customers",
          "type": "simple",
          "link": "/home/customers"
        },
        {
          "title": "Agencies",
          "type": "simple",
          "link": "/home/agencies"
        },
      
        {
          "title": "Settings",
          "type": "simple",
          "link": "/home/settings"
        },
        {
          "title": "System Settings",
          "type": "simple",
          "link": "/home/setting-home"
        },
      ]
    },
  ];

  currentUserName;
  isStationManager = false;
  isFromLoginPage;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private modalService: BsModalService,
    private employeeService: EmployeeService,
    private appAttrService: AppAttributesService
  ) { }

  ngOnInit() {
    this.isStationManager = this.authenticationService.isStationAdmin();
    this.currentUserName = localStorage.getItem('currentUserName')
    if (this.router.url === '/home') {
      if (this.authenticationService.getAccessLevel() == AccessLevels.superAdmin) {
        this.router.navigateByUrl('/home/dashone');
      } else if (this.authenticationService.getAccessLevel() == AccessLevels.stationManager) {
        this.router.navigateByUrl('/home/dashtwo');
      } else {
        this.router.navigateByUrl('/login');
      }
    }
  }

  showChangePasswordAlert() {
    const initialState = {
      title: "Are you sure you want to delete this service?"
    };
    const modalRef = this.modalService.show(WarningConfirmModalComponent, { initialState });
    modalRef.setClass('modal-lg modal-dialog-centered modal-dialog-scrollable');
    modalRef.content.event.subscribe(res => {
      if (res.data) {
        // this.services.splice(index, 1);
      } else {
        modalRef.hide()
      }
    })
  }

  loadAppAttributes() {
    let userType = this.authenticationService.isStationAdmin() ? 'station-admin' : 'admin';
    this.spinner.show();
    this.appAttrService.loadAttributes(userType, this.authenticationService.getCurrentUserId())
      .subscribe(res => {
        this.appAttrService.setAppAttributes(res['result']);
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
      })
  }


  logout() { }


  changePassword() {
    this.spinner.show()
    if (this.authenticationService.isStationAdmin()) {
      this.employeeService.getEmployeeProfile(this.authenticationService.getCurrentUserId()).subscribe((res) => {
        this.spinner.hide()
        if (res['status']) {
        }
      })
    } else {
      this.employeeService.getSuperAdminDetails(this.authenticationService.getCurrentUserId()).subscribe((res) => {
        this.spinner.hide()
        if (res['status']) {
          // this.openDialog(res['result'])
        }
      })
    }
  }


  // openDialog(userData) {
  //   const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
  //     // height: '30em',
  //     width: '40em',
  //     data: userData
  //   });
  //   dialogRef.disableClose = true;
  // }

  getMenuList() {
    return this.menus;
  }

  getMenuItemByUrl(aMenus: MenuItem[], aUrl: string): MenuItem {
    for (const theMenu of aMenus) {
      if (theMenu.link && theMenu.link === aUrl) {
        return theMenu;
      }

      if (theMenu.submenus && theMenu.submenus.length > 0) {
        const foundItem = this.getMenuItemByUrl(theMenu.submenus, aUrl);
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return undefined;
  }

  toggleMenuItem(aMenus: MenuItem[], aCurrentMenu: MenuItem): MenuItem[] {
    return aMenus.map((aMenu: MenuItem) => {
      if (aMenu === aCurrentMenu) {
        aMenu.active = !aMenu.active;
      } else {
        aMenu.active = false;
      }

      if (aMenu.submenus && aMenu.submenus.length > 0) {
        aMenu.submenus = this.toggleMenuItem(aMenu.submenus, aCurrentMenu);

        if (aMenu.submenus.find(aChild => aChild.active)) {
          aMenu.active = true;
        }
      }
      return aMenu;
    });
  }
}
